<template>
    <v-row justify="center">
        <v-dialog v-model="showDialog" persistent max-width="600" no-horizontal-scroll>
            <v-card no-horizontal-scroll>
                <v-card-title class="headline pt-1 pr-1 custom-card-header">
                    Archive Overdue Tasks
                    <v-spacer></v-spacer>
                    <v-btn icon @click="toggle" dark><v-icon>close</v-icon></v-btn>
                </v-card-title>
                <div v-if="disabled" class="text-center">
                    Saving<br />
                    <v-progress-circular
                        indeterminate
                        color="success"
                        v-if="disabled"
                    ></v-progress-circular>
                </div>
                <div v-else>
                    <v-card-text class="ma-2 largeFont">{{ overdueTasks.length > 0 ? 'Clicking archive will remove the following tasks:' : 'No Overdue Tasks'}}</v-card-text>
                    <span v-for="(task, index) in overdueTasks" v-bind:key="index">
                        <v-card-text class="red-text">{{ task.text }}</v-card-text>
                    </span>
                </div>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="primary" class="ma-2" @click="archive">Archive</v-btn>
                    <v-btn color="primary" outlined class="ma-2" @click="toggle">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex'
    export default {
        name: 'archive-outdated',
        props: {
            showDialog: {
                type: Boolean,
                required: true
            },
            toggle: {
                type: Function,
                required: true
            }
        },
        data () {
            return {
                disabled: false,
                archiveOverdue: false
            }
        },
        methods: {
            ...mapActions({
                archiveGroup: 'jobTasks/archiveGroup',
            }),
            async archive() {
                this.disabled = true
                let idList = []
                this.overdueTasks.map(t => {
                    idList.push(t.value)
                })
                await this.archiveGroup(idList)
                this.archiveOverdue = !(this.archiveOverdue)
                this.disabled = false
            }
        },
        computed: {
            ...mapGetters({
                overdueTasks: 'jobTasks/overdueTasks'
            })
        }
    }
</script>
<style>
    .custom-card-header {
        background-color: #00A5C5;
        color: white;
    }
    .no-horizontal-scroll {
        overflow-y: auto
    }
    .red-text {
        color:red
    }
    .largeFont {
        font-size: 17px;
        font-weight: bold;
    }
</style>
